import { provideGridCore } from '@frontend/sports/grid/core/feature/store';
import { provideEffects } from '@ngrx/effects';

import { CompetitionGridTrackingEffects } from './competition-grid-tracking.epic';
import { CompetitionGridEffects } from './competition-grid.epic';
import { CouponGridEffects } from './coupon-grid.epic';

export function provideGrid() {
    return [provideEffects([CouponGridEffects, CompetitionGridTrackingEffects, CompetitionGridEffects]), provideGridCore()];
}
